import CommonTitleBar from "components/common/CommonTitleBar";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Notification from "assets/images/icons/notification.svg";
import PrivacyPolicy from "assets/images/icons/privacyPolicy.svg";
import { useDispatch, useSelector } from "react-redux";
import { getSettingsList } from "store/actions/globalSettingSlice";
import { formatDate, setPageTitle } from "components/common/Utils";
import Spinners from "components/common/Spinners";

const Settings = () => {
  const { t } = useTranslation();
    setPageTitle("Settings" ,t);

  

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loading, settingsList } = useSelector(
    (state) => state.GlobalSettings
  );

  const [settingsData, setSettingsData] = useState([]);

  const staticConfig = {
    1: {
      title: "Notifications Message",
      titleAr: "Notifications Message",
      redirectLink: "/management/settings/notifications",
      iconUrl: Notification,
    },
    2: {
      title: "Privacy And Security",
      titleAr: "Privacy And Security",
      redirectLink: "/management/settings/privacy-and-security",
      iconUrl: PrivacyPolicy,
    },
    3: {
      title: "Introduction Page",
      titleAr: "Introduction Page",
      redirectLink: "/management/settings/introduction-page",
    },
    4: {
      title: "Cancellation Policies",
      titleAr: "Cancellation Policies",
      redirectLink: "/management/settings/cancellation-policies",
    },
    5: {
      title: "Terms And Conditions",
      titleAr: "Terms And Conditions",
      redirectLink: "/management/settings/terms-and-conditions",
    },
    6: {
      title: "Global Settings",
      titleAr: "Global Settings",
      redirectLink: "/management/settings/global-settings",
    },
  };

  useEffect(() => {
    dispatch(getSettingsList());
  }, []);

  useEffect(() => {
    if (!loading && settingsList?.length > 0) {
      const mergedRewardsData = settingsList.map((item) => {
        const staticInfo = staticConfig[item.id] || {};

        return {
          ...item,
          lastEditedIOn: formatDate(item.lastUpdatedOn),
          editedBy: item.editedBy?.name || "",
          ...staticInfo,
        };
      });
      setSettingsData(mergedRewardsData);
    }
  }, [settingsList]);

  return (
    <React.Fragment>
      <div className="page-content common_page ">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <CommonTitleBar title={t("Settings")} />
            <div className="common_wrapper settings pt-2">
              <Row>
                {settingsData?.map((item) => (
                  <Col lg={4} key={item?.id}>
                    <div
                      className={`top_bar c_p `}
                      onClick={() => navigate(item?.redirectLink)}
                    >
                      <div className="content">
                        <div className="d-flex gap-2 align-items-center">
                          {item?.iconUrl && (
                            <img
                              src={item?.iconUrl}
                              alt="icon"
                              width={20}
                              height={20}
                            />
                          )}
                          <h2>{item?.title}</h2>
                        </div>

                        <div className="g_between bottom_div">
                          <p>
                            <span className="">{t("Last Edit on")}</span>:{" "}
                            {item?.lastEditedIOn} {t("by")}{" "}
                            <span className="text-decoration">
                              {item?.editedBy}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default Settings;
